module.exports = __webpack_public_path__ + "img/15-Steel Technology.e6099be4.png";